import { FC } from 'react'
import { FlaskConical } from 'lucide-react'
import { useDemoMode } from '@utils/demoMode'

export const DemoModeBanner: FC = () => {
  const demoMode = useDemoMode()

  if (!demoMode) return null

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 bg-amber-500 text-white text-center text-xs font-medium py-1 px-4 flex items-center justify-center gap-1.5 pointer-events-none">
      <FlaskConical className="h-3.5 w-3.5" />
      Modo demostración activo — los datos mostrados no son reales
    </div>
  )
}
